export default class ImageDownloadIncludeCamera {
  public idImageDownloadIncludeCamera: number = 0;
  public cameraName: string = "";
  public imageType: string | undefined;
}
